import PageContainer from '@/components/layout/page-container';
import { Heading } from '@/components/ui/heading';
import { useAuthStore } from '@/store/auth';
import InquiryTable from '@/modules/help/inquiry-table';

export default function InquiryPage() {
  const context = useAuthStore((state) => state.context);

  // Only allow workspace users to access this page
  if (context !== 'workspace') {
    return (
      <PageContainer scrollable={true}>
        <div className='flex h-full items-center justify-center'>
          <div className='text-center'>
            <h2 className='text-2xl font-semibold text-gray-900'>Access Denied</h2>
            <p className='mt-2 text-gray-600'>
              This page is only available for workspace users.
            </p>
          </div>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer scrollable={true}>
      <div className='mb-5 flex items-center justify-between px-4'>
        <Heading 
          title='Inquiries' 
          description='Manage and respond to user inquiries' 
        />
      </div>
      
      <div className='h-full space-y-4 bg-white py-3'>
        <InquiryTable />
      </div>
    </PageContainer>
  );
}
